import React, { useState, useEffect } from "react";
import { Button, FormControlLabel, FormGroup, Switch, Typography, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ForumIcon from '@mui/icons-material/Forum';

export default function ProjectVisibilityManagement(props) {
  const { projectData, handleChange } = props;
  const [isPublic, setIsPublic] = useState(projectData?.ispublic || false);
  const [isCommentingEnabled, setIsCommentingEnabled] = useState(projectData?.allowcomments || false);
  const projectUrl = React.useMemo(() => window.location.href.replace("project", "p"), []);

  useEffect(() => {
    setIsPublic(projectData?.ispublic || false);
    setIsCommentingEnabled(projectData?.allowcomments || false);
  }, [projectData]);

  const handleShareState = () => {
    setIsPublic(prev => {
      const newValue = !prev;
      handleChange({ target: { name: "ispublic", value: newValue } });
      return newValue;
    });
  };

  const handleCommentsState = () => {
    setIsCommentingEnabled(prev => {
      const newValue = !prev;
      handleChange({ target: { name: "allowcomments", value: newValue } });
      return newValue;
    });
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(projectUrl);
  };

  return (
    <div>
      <Typography variant="caption">
        Share your project with public.
      </Typography>
      <FormGroup>
        <FormControlLabel control={<Switch onChange={handleShareState} checked={isPublic} />} label="Share" />
        {isPublic && (
          <FormControl sx={{ width: '100%', my: 2 }} variant="outlined">
            <InputLabel>Project URL</InputLabel>
            <OutlinedInput
              size="small"
              id="outlined-adornment-project-url"
              type="text"
              sx={{ width: "100%" }}
              value={projectUrl}
              readOnly
              disabled
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Copy project URL"
                    onClick={handleCopy}
                    edge="end"
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              }
              label="Project URL"
            />
          </FormControl>
        )}
        <Typography variant="caption">Comments are visible for everyone</Typography>
        <FormControlLabel control={<Switch disabled={!isPublic} onChange={handleCommentsState} checked={isCommentingEnabled} />} label="Allow comments" />
        <Button
          variant="outlined"
          color="inherit"
          fullWidth
          startIcon={<ForumIcon fontSize="small" />}
        >
          Show Comments
        </Button>
      </FormGroup>
    </div>
  );
}